import React from "react";
import { Twitter, Linkedin, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TheVisionaryBehindTheBrand() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const socialLinks = [{
    icon: Twitter,
    href: "https://twitter.com/spiritwithhuman",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "https://ca.linkedin.com/in/joe-west-b6b29195",
    label: "LinkedIn"
  }, {
    icon: Instagram,
    href: "https://instagram.com/joe_west_inspections",
    label: "Instagram"
  }];
  return <section id="the-visionary-behind-the-brand" className="bg-background overflow-hidden ![padding:30px_0px_96px_0px]">
      <div ref={ref} className={cn("max-w-7xl mx-auto px-8 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-8 tracking-tight">Why Choose Me?</h2>

            <div className="space-y-6 text-lg text-muted-foreground leading-[1.7]">
              <p>I am the only Home Inspector in Grey &amp; Bruce Counties with experience as a Municipal Building Inspector, General Contractor, and Architectural Designer.<br /><br />Fast Bookings and same-day reports to fit your schedule.&nbsp;<br /><br />I have renovated older homes, rural properties, and condos/townhomes (the issues and systems are different.) &nbsp;<br /><br />A prioritized report (Safety • Water • Structure • Electrical • HVAC) — not just a long list.&nbsp;<br /><br />I am here to ensure your dream home does not turn into a money pit nightmare. <br /><br />Whether you're buying your dream home,&nbsp;building a new home, adding an addition or renovating your existing home, or just need some small handyman service. I am here to support you in making the best decisions.&nbsp; <br /></p>
              
              
            </div>

            {}
            <div className="mt-10 flex items-center gap-4">
              {socialLinks.map((social, i) => <Link key={social.label} to={social.href} newTab className="group relative flex items-center justify-center w-12 h-12 rounded-full text-foreground/80 hover:text-foreground hover:bg-accent transition-all duration-300" aria-label={social.label} data-index={i}>
                  <social.icon className="w-5 h-5 transition-transform duration-300 group-hover:scale-110" />
                </Link>)}
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative mt-8 lg:mt-0">
            {}
            <div className="relative lg:translate-y-8 lg:translate-x-4">
              <img src="https://equipped-jaguar.10web.cloud/wp-content/uploads/2026/02/ChatGPT-Image-Feb-20-2026-at-03_03_53-PM.png" alt="Joe West - The Visionary Behind the Brand" className="w-full h-auto object-cover rounded-2xl border border-border shadow-lg" />
              {}
            </div>
          </div>
        </div>
      </div>
    </section>;
}